import React from "react";
import { Helmet } from "react-helmet-async";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Helmet>
        <title>Privacy Policy – OjoVest</title>
        <link rel="canonical" href="https://www.ojovest.com/privacy" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-12">
        <h1 className="text-3xl font-semibold tracking-tight">Privacy Policy</h1>
        <p className="mt-3 text-sm text-slate-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="mt-8 space-y-5 text-sm leading-7 text-slate-700">
          <p>
            We collect information you submit (name, phone, email, financial details you choose to share)
            to assist with services. We do not sell personal data.
          </p>
          <p>
            We may share details with banks/NBFCs/issuers only for processing applications with your consent.
          </p>
          <p>
            You can request deletion by emailing support@ojovest.com from your registered email.
          </p>
        </div>
      </div>
    </div>
  );
}
